export const style = {
  section: {
    background: `#A94545`,
    padding: `30px 0`
  },
  h3: {
    color: `white`,
    fontSize: `18px`,
    fontWeight: 800,
    margin: `0 0 8px 0`,
    '@media only screen and (min-width: 992px)': {
      fontSize: `1.8rem`,
      fontWeight: 300
    }
  },
  p: {
    color: `white`,
    margin: 0,
    padding: 0,
    fontSize: `16px`,
    fontWeight: 300
  },
  link: {
    marginTop: `20px`,
    color: `white`,
    fontSize: `18px`,
    lineHeight: 1.3333333,
    border: `1px solid rgba(255, 255, 255, 0.3)`,
    background: `#AD5251`,
    padding: `10px 16px`,
    textDecoration: `none`,
    transition: `0.2s`,
    ':hover': {
      background: `rgba(255, 255, 255, 0.0)`
    },
    '@media only screen and (min-width: 992px)': {
      marginTop: 0
    }
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Home/style/signup.js